// extracted by mini-css-extract-plugin
export default {"contentRow":"_2QdoM","cover":"_1NxZD","main":"cEExN","contentContainer":"_1NGJl","title":"Z4gRR","link":"_2vCWh","content":"_35eIu","header":"_1bB4Z","name":"_2ULtk","date":"_2ZVbw"};